import { useReducer, useEffect, useRef } from "react";
import { editorReducer, initialEditorState } from "./editor-reducer";
import type { EditorDraft } from "./editor-types";

/**
 * Custom hook to manage the local editor draft state.
 * Initializes the local draft from the server snapshot once.
 * Subsequent updates and saves are managed strictly by reducer actions.
 */
export function useEditorDraft(serverSnapshot: EditorDraft | null) {
  const [state, dispatch] = useReducer(editorReducer, initialEditorState);
  const isInitializedRef = useRef(false);

  useEffect(() => {
    if (!serverSnapshot) return;

    if (!isInitializedRef.current || !state.draft) {
      dispatch({ type: "SET_INITIAL_DRAFT", payload: serverSnapshot });
      isInitializedRef.current = true;
    }
  }, [serverSnapshot, state.draft]);

  return {
    state,
    dispatch,
  };
}
